export default "__VITE_ASSET__DLye0iML__"